import { USDollar } from 'utils/format';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'GlobalContext';
import { InvestorsTableViewSubTable } from './InvestorsTableViewSubTable';
import { USD_TO_CNY } from 'utils/format';

export function InvestorsTableViewTable(props) {
    const {
        allPositions,
        accountIdToInvestorsAll,
        filteredText,
        backgroundColors,
        panelBackgroundColor,
    } = props;
    const { setManageRecordId, setManageRecordTab } = useContext(GlobalContext);

    const [localAccountIdToInvestors, setLocalAccountIdToInvestors] = useState(
        accountIdToInvestorsAll
    );
    function getAllInvestorIds(localAccountIdToInvestors) {
        var investorIds = new Set();
        for (const accountId of Object.keys(localAccountIdToInvestors)) {
            for (const investor of localAccountIdToInvestors[accountId]) {
                if (investor.investor_id) {
                    investorIds.add(investor.investor_id);
                }
            }
        }
        return investorIds;
    }
    const [investorIds, setInvestorIds] = useState(
        getAllInvestorIds(localAccountIdToInvestors)
    );

    // console.log(allPositions)
    // console.log('accountIdToInvestorsAll', accountIdToInvestorsAll);
    // console.log('localAccountIdToInvestors', localAccountIdToInvestors);

    function includesIgnoreCase(text, query) {
        if (!query) return true;
        if (!text) return false;
        return text.toLowerCase().includes(query.toLowerCase());
    }

    useEffect(() => {
        const filteredEntries = Object.entries(accountIdToInvestorsAll).filter(
            ([accountId, investors]) => {
                return investors.some(
                    (investor) =>
                        includesIgnoreCase(
                            investor.account_name,
                            filteredText
                        ) ||
                        includesIgnoreCase(investor.email, filteredText) ||
                        includesIgnoreCase(investor.legal_name, filteredText)
                );
            }
        );

        const filteredMap = Object.fromEntries(filteredEntries);

        setLocalAccountIdToInvestors(filteredMap);
        setInvestorIds(getAllInvestorIds(filteredMap));
    }, [filteredText, accountIdToInvestorsAll]);

    const tableWidth = '1550px';
    const center = {
        display: 'flex',
        alignItems: 'center',
        placeContent: 'center',
        textAlign: 'center',
    };
    return (
        <>
            {' '}
            {allPositions && (
                <div style={{ width: '100%', overflow: 'auto' }}>
                    <div>{`Investor Count: ${
                        investorIds.size
                    }, account count: ${
                        Object.keys(localAccountIdToInvestors).length
                    }`}</div>

                    <div style={{ width: tableWidth }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                // borderBottom: '1px solid black',
                                background: panelBackgroundColor,
                                borderRadius: '4px 4px 0 0',
                            }}
                        >
                            <div style={{ width: '150px', ...center }}>
                                Investors
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Investment Entities
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Funds
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Commitment Number
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Equity Balance
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Distribute Interest
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Principal Return
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Interest Rate
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                Capital In Date
                            </div>
                            <div style={{ width: '150px', ...center }}>
                                End Date
                            </div>
                        </div>
                        {Object.keys(localAccountIdToInvestors)
                            .sort((a, b) => {
                                const amount_a = allPositions
                                    .filter(
                                        (position) =>
                                            position.account_id === parseInt(a)
                                    )
                                    .reduce((acc, cur) => {
                                        const amount =
                                            cur.currency.toLowerCase() === 'cny'
                                                ? cur.account_balance /
                                                  USD_TO_CNY
                                                : cur.account_balance;
                                        return acc + amount;
                                    }, 0);

                                const amount_b = allPositions
                                    .filter(
                                        (position) =>
                                            position.account_id === parseInt(b)
                                    )
                                    .reduce((acc, cur) => {
                                        const amount =
                                            cur.currency.toLowerCase() === 'cny'
                                                ? cur.account_balance /
                                                  USD_TO_CNY
                                                : cur.account_balance;
                                        return acc + amount;
                                    }, 0);
                                if (amount_a < amount_b) {
                                    return 1;
                                }
                                return -1;
                            })
                            .map((account_id, id) => (
                                <InvestorsTableViewSubTable
                                    key={id}
                                    account_id={account_id}
                                    investors={
                                        accountIdToInvestorsAll[account_id]
                                    }
                                    positions={allPositions.filter(
                                        (position) =>
                                            position.account_id ===
                                            parseInt(account_id)
                                    )}
                                    background={backgroundColors[id % 2]}
                                />
                            ))}
                    </div>
                </div>
            )}
        </>
    );
}
